import React, { useEffect, useState } from "react";
import api from "../../services/api";

const FloupPage = () => {
  const [floups, setFloups] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [form, setForm] = useState({ 
    id: null, 
    name: "", 
    description: "", 
    templateType: "personalizado", 
    condition: "queue", 
    conditionValue: "", 
    steps: [], 
    stopConditions: [], 
    pauseConditions: [] 
  });
  const [preview, setPreview] = useState("");
  const [tags, setTags] = useState([]);
  const [queues, setQueues] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [floupToDelete, setFloupToDelete] = useState(null);

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('typeArch', 'floup');
    if (form.id) {
      formData.append('floupId', form.id.toString());
    }
    try {
      console.log('[FLOUP] uploadFile → Iniciando upload:', { fileName: file.name, fileSize: file.size, fileType: file.type, floupId: form.id });
      const response = await api.post('/plugins/floup/upload', formData, { 
        headers: { 
          'Content-Type': 'multipart/form-data' 
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log('[FLOUP] uploadFile → Progresso:', percentCompleted + '%');
        }
      });
      console.log('[FLOUP] uploadFile → Resposta completa do servidor:', response.data);
      if (response.data && response.data.url) {
        console.log('[FLOUP] uploadFile → URL retornada:', response.data.url);
        return response.data.url;
      } else {
        console.error('[FLOUP] uploadFile → Resposta sem URL:', response.data);
        return null;
      }
    } catch (error) {
      console.error('[FLOUP] uploadFile → Erro completo:', error);
      console.error('[FLOUP] uploadFile → Erro response:', error.response?.data);
      console.error('[FLOUP] uploadFile → Erro status:', error.response?.status);
      return null;
    }
  };

  const deleteFile = async (fileUrl) => {
    if (!fileUrl) {
      console.warn('[FLOUP] deleteFile → URL vazia, nada para deletar');
      return;
    }
    try {
      console.log('[FLOUP] deleteFile → Iniciando remoção do arquivo:', fileUrl);
      const response = await api.delete('/plugins/floup/upload', { 
        data: { fileUrl } 
      });
      console.log('[FLOUP] deleteFile → Arquivo removido com sucesso:', response.data);
      return true;
    } catch (error) {
      console.error('[FLOUP] deleteFile → Erro ao remover arquivo:', error);
      console.error('[FLOUP] deleteFile → Erro response:', error.response?.data);
      console.error('[FLOUP] deleteFile → Erro status:', error.response?.status);
      return false;
    }
  };

  const load = async () => {
    const { data } = await api.get("/plugins/floup");
    setFloups(data);
    try { const { data: tagList } = await api.get('/tags/list'); setTags(tagList || []); } catch {}
    try { const { data: queueList } = await api.get('/queue'); setQueues(queueList || []); } catch {}
  };

  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    const stepsWithDefaults = form.steps.map((step, index) => {
      const stepData = {
        order: step.order || (index + 1),
        message: step.message || '',
        timeUnit: step.timeUnit || 'minutes',
        timeValue: step.timeValue || 0,
        mediaUrl: step.mediaUrl || '',
        mediaType: step.mediaType || 'url'
      };
      
      if (step.mediaUrl) {
        console.log(`[FLOUP] handleSave → Step ${index + 1} (order ${stepData.order}) tem mediaUrl:`, step.mediaUrl);
      }
      
      return stepData;
    });
    
    const payload = { 
      name: form.name, 
      description: form.description, 
      templateType: form.templateType, 
      condition: form.condition || "queue",
      conditionValue: form.conditionValue || "",
      isActive: true, 
      steps: stepsWithDefaults, 
      stopConditions: form.stopConditions || [], 
      pauseConditions: form.pauseConditions || [] 
    };
    
    console.log('[FLOUP] handleSave → Payload completo:', JSON.stringify(payload, null, 2));
    console.log('[FLOUP] handleSave → Total de steps:', stepsWithDefaults.length);
    console.log('[FLOUP] handleSave → Steps com mediaUrl:', stepsWithDefaults.filter(s => s.mediaUrl && s.mediaUrl.trim() !== '').map(s => ({ order: s.order, mediaUrl: s.mediaUrl, mediaType: s.mediaType })));
    
    try {
      if (form.id) {
        const response = await api.put(`/plugins/floup/${form.id}`, payload);
        console.log('[FLOUP] handleSave → Resposta do PUT:', response.data);
      } else {
        const response = await api.post(`/plugins/floup`, payload);
        console.log('[FLOUP] handleSave → Resposta do POST:', response.data);
      }
      
      setOpen(false);
      resetForm();
      await load();
    } catch (error) {
      console.error('[FLOUP] handleSave → Erro ao salvar:', error);
      console.error('[FLOUP] handleSave → Erro detalhado:', error.response?.data);
      console.error('[FLOUP] handleSave → Status:', error.response?.status);
      console.error('[FLOUP] handleSave → Mensagem:', error.message);
      
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'Erro desconhecido';
      alert(`Erro ao salvar o Follow UP: ${errorMessage}\n\nVerifique o console para mais detalhes.`);
    }
  };

  const resetForm = () => {
    setForm({ id: null, name: "", description: "", templateType: "personalizado", condition: "queue", conditionValue: "", steps: [], stopConditions: [], pauseConditions: [] });
    setCurrentStep(0);
    setPreview("");
  };

  const handleDelete = (id) => {
    const floup = floups.find(f => f.id === id);
    setFloupToDelete({ id, name: floup?.name || 'este floup' });
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (floupToDelete) {
      try {
        await api.delete(`/plugins/floup/${floupToDelete.id}`);
        await load();
        setDeleteConfirmOpen(false);
        setFloupToDelete(null);
      } catch (error) {
        console.error('[FLOUP] Erro ao deletar floup:', error);
        alert('Erro ao deletar o Follow UP. Verifique o console para mais detalhes.');
      }
    }
  };

  const handleDuplicate = async (id) => { 
    await api.post(`/plugins/floup/${id}/duplicate`); 
    await load(); 
  };

  const handleExport = (id) => {
    const floup = floups.find(f => f.id === id);
    if (!floup) return;
    
    const exportData = {
      name: floup.name,
      description: floup.description,
      templateType: floup.templateType,
      condition: floup.condition,
      conditionValue: floup.conditionValue,
      steps: floup.steps,
      stopConditions: floup.stopConditions,
      pauseConditions: floup.pauseConditions,
      exportedAt: new Date().toISOString(),
      version: "1.0"
    };
    
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `floup_${floup.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_${Date.now()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleExportAll = () => {
    if (floups.length === 0) {
      alert('Não há fluxos para exportar.');
      return;
    }
    
    const exportData = {
      floups: floups.map(f => ({
        name: f.name,
        description: f.description,
        templateType: f.templateType,
        condition: f.condition,
        conditionValue: f.conditionValue,
        steps: f.steps,
        stopConditions: f.stopConditions,
        pauseConditions: f.pauseConditions
      })),
      exportedAt: new Date().toISOString(),
      version: "1.0",
      count: floups.length
    };
    
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `floups_backup_${Date.now()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const importData = JSON.parse(e.target.result);
        
        // Verifica se é um arquivo de múltiplos fluxos ou único
        const fluxosToImport = importData.floups ? importData.floups : [importData];
        
        let successCount = 0;
        let errorCount = 0;
        
        for (const fluxo of fluxosToImport) {
          try {
            const payload = {
              name: `${fluxo.name} (Importado)`,
              description: fluxo.description || "",
              templateType: fluxo.templateType || "personalizado",
              condition: fluxo.condition || "queue",
              conditionValue: fluxo.conditionValue || "",
              isActive: false,
              steps: fluxo.steps || [],
              stopConditions: fluxo.stopConditions || [],
              pauseConditions: fluxo.pauseConditions || []
            };
            
            await api.post('/plugins/floup', payload);
            successCount++;
          } catch (error) {
            console.error('[FLOUP] Erro ao importar fluxo:', error);
            errorCount++;
          }
        }
        
        await load();
        
        if (errorCount === 0) {
          alert(`✅ ${successCount} fluxo(s) importado(s) com sucesso!`);
        } else {
          alert(`⚠️ ${successCount} fluxo(s) importado(s) com sucesso.\n${errorCount} fluxo(s) com erro.`);
        }
      } catch (error) {
        console.error('[FLOUP] Erro ao processar arquivo:', error);
        alert('❌ Erro ao importar arquivo. Verifique se o formato está correto.');
      }
    };
    
    reader.readAsText(file);
    event.target.value = '';
  };

  const updateStep = (idx, key, value) => {
    setForm(prevForm => {
      const steps = [...prevForm.steps];
      if (!steps[idx]) {
        console.warn(`[FLOUP] updateStep → Step ${idx} não existe, criando novo step`);
        steps[idx] = { order: idx + 1, message: "", timeUnit: "minutes", timeValue: 0, mediaUrl: "", mediaType: "url" };
      }
      const updatedStep = { ...steps[idx], [key]: value };
      steps[idx] = updatedStep;
      console.log(`[FLOUP] updateStep → Atualizando step ${idx}, campo ${key}:`, { oldValue: steps[idx]?.[key], newValue: value, updatedStep });
      const newForm = { ...prevForm, steps };
      if (key === "message") setPreview(value);
      return newForm;
    });
  };

  const addStep = () => {
    const newStep = { order: form.steps.length + 1, message: "", timeUnit: "minutes", timeValue: 0, mediaUrl: "", mediaType: "url" };
    setForm({ ...form, steps: [...form.steps, newStep] });
  };

  const removeStep = (idx) => setForm({ ...form, steps: form.steps.filter((_, i) => i !== idx).map((s, i) => ({ ...s, order: i + 1 })) });

  const getTemplateTypeConfig = (type) => {
    switch (type) {
      case "cliente":
        return { title: "Template para Clientes", description: "Fluxo automatizado para clientes existentes", defaultSteps: [{ order: 1, message: "Olá! Como podemos ajudá-lo hoje?", timeUnit: "minutes", timeValue: 0, mediaUrl: "", mediaType: "url" }] };
      case "lead":
        return { title: "Template para Leads", description: "Fluxo de nutrição para novos leads", defaultSteps: [{ order: 1, message: "Olá! Bem-vindo! Temos uma oferta especial para você.", timeUnit: "hours", timeValue: 2, mediaUrl: "", mediaType: "url" }] };
      case "personalizado":
      default:
        return { title: "Template Personalizado", description: "Crie seu próprio fluxo com condições específicas", defaultSteps: [] };
    }
  };

  const isImageFile = (url) => {
    if (!url) return false;
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.startsWith('data:image/')) return true;
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    if (imageExtensions.some(ext => lowerUrl.includes(ext))) return true;
    if (lowerUrl.includes('image') && (lowerUrl.includes('http') || lowerUrl.includes('https'))) return true;
    return false;
  };

  const isVideoFile = (url) => {
    if (!url) return false;
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.startsWith('data:video/')) return true;
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv', '.flv', '.wmv'];
    if (videoExtensions.some(ext => lowerUrl.includes(ext))) return true;
    if (lowerUrl.includes('video') && (lowerUrl.includes('http') || lowerUrl.includes('https'))) return true;
    return false;
  };

  const renderStepForm = (step, idx) => (
    <div key={idx} style={{ marginBottom: 16, border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
      <div 
        onClick={() => setCurrentStep(currentStep === idx ? -1 : idx)}
        style={{ 
          padding: '12px 16px', 
          background: '#f5f7fa', 
          cursor: 'pointer', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          borderBottom: currentStep === idx ? '1px solid #e0e0e0' : 'none'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontWeight: 600, fontSize: 16 }}>Passo {step.order}</span>
          <span style={{ 
            padding: '4px 8px', 
            borderRadius: 4, 
            background: step.message ? 'var(--primaryColor, #065183)' : '#e0e0e0', 
            color: step.message ? '#fff' : '#666',
            fontSize: 12
          }}>
            {step.message ? step.message.substring(0, 30) + "..." : "Mensagem vazia"}
          </span>
          {step.mediaUrl && (
            <span style={{ 
              padding: '4px 8px', 
              borderRadius: 4, 
              background: '#ff9800', 
              color: '#fff',
              fontSize: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 4
            }}>
              📎 Anexo
            </span>
          )}
        </div>
        <span style={{ fontSize: 20, transform: currentStep === idx ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>▼</span>
      </div>
      {currentStep === idx && (
        <div style={{ padding: 16, background: '#fff' }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Mensagem</label>
            <textarea 
              value={step.message} 
              onChange={e => updateStep(idx, "message", e.target.value)} 
              maxLength={500}
              rows={3}
              style={{ 
                width: '100%', 
                padding: 8, 
                border: '1px solid #e0e0e0', 
                borderRadius: 4,
                fontFamily: 'inherit',
                fontSize: 14
              }}
            />
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{(step.message || "").length}/500 caracteres</div>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Valor</label>
              <input 
                type="number" 
                value={step.timeValue || 0} 
                onChange={e => updateStep(idx, "timeValue", parseInt(e.target.value || "0"))} 
                min={0}
                style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Unidade de Tempo</label>
              <select 
                value={step.timeUnit || "minutes"} 
                onChange={e => updateStep(idx, "timeUnit", e.target.value)}
                style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
              >
                <option value="minutes">Minutos</option>
                <option value="hours">Horas</option>
                <option value="days">Dias</option>
                <option value="weeks">Semanas</option>
                <option value="months">Meses</option>
                <option value="years">Anos</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>&nbsp;</label>
              <div style={{ padding: 8, color: '#666', fontSize: 14 }}>
                Enviar após {step.timeValue || 0} {step.timeUnit || "minutes"}
              </div>
            </div>
          </div>
          
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Anexo/Link</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <select 
                value={step.mediaType || "url"} 
                onChange={e => updateStep(idx, "mediaType", e.target.value)}
                style={{ padding: '6px 12px', border: '1px solid #e0e0e0', borderRadius: 4, minWidth: 100 }}
              >
                <option value="url">Link</option>
                <option value="upload">Upload</option>
              </select>
              
              {step.mediaType === "url" ? (
                <div style={{ flex: 1, minWidth: 150, maxWidth: 400, position: 'relative' }}>
                  <input 
                    type="text"
                    placeholder="Cole a URL aqui" 
                    value={step.mediaUrl || ""} 
                    onChange={e => updateStep(idx, "mediaUrl", e.target.value)} 
                    style={{ 
                      width: '100%', 
                      padding: '6px 12px', 
                      paddingLeft: 32,
                      paddingRight: step.mediaUrl ? 60 : 12,
                      border: '1px solid #e0e0e0', 
                      borderRadius: 4 
                    }}
                  />
                  <span style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', fontSize: 16 }}>🔗</span>
                  {step.mediaUrl && (
                    <div style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 4 }}>
                      {isImageFile(step.mediaUrl) && (
                        <img 
                          src={step.mediaUrl} 
                          alt="Preview" 
                          style={{ 
                            width: 24, 
                            height: 24,
                            objectFit: 'cover', 
                            borderRadius: 2,
                            border: '1px solid #e0e0e0'
                          }}
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                      )}
                      {isVideoFile(step.mediaUrl) && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            const videoUrl = step.mediaUrl;
                            const newWindow = window.open('', '_blank');
                            if (newWindow) {
                              newWindow.document.write(`
                                <html>
                                  <head><title>Player de Vídeo</title></head>
                                  <body style="margin:0;padding:0;background:#000;display:flex;justify-content:center;align-items:center;height:100vh;">
                                    <video controls autoplay style="max-width:100%;max-height:100%;">
                                      <source src="${videoUrl}" type="video/mp4">
                                      Seu navegador não suporta o elemento de vídeo.
                                    </video>
                                  </body>
                                </html>
                              `);
                            }
                          }}
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: 2,
                            border: '1px solid #e0e0e0',
                            overflow: 'hidden',
                            position: 'relative',
                            cursor: 'pointer',
                            flexShrink: 0
                          }}
                        >
                          <video
                            src={step.mediaUrl}
                            preload="metadata"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                          <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            borderRadius: '50%',
                            padding: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <span style={{ fontSize: 12, color: '#fff' }}>▶</span>
                          </div>
                        </div>
                      )}
                      <button
                        onClick={() => {
                          updateStep(idx, "mediaUrl", "");
                          updateStep(idx, "uploadedFile", null);
                        }}
                        title="Remover link"
                        style={{ 
                          padding: 4, 
                          border: 'none', 
                          background: 'transparent', 
                          cursor: 'pointer',
                          fontSize: 16
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <input 
                    accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.txt" 
                    style={{ display: 'none' }} 
                    id={`file-upload-${idx}`} 
                    type="file" 
                    onChange={async (e) => { 
                      const inputElement = e.target;
                      const file = e.target.files[0]; 
                      if (file) { 
                        console.log('[FLOUP] onChange → Upload iniciado:', { stepIndex: idx, fileName: file.name, fileSize: file.size, fileType: file.type });
                        updateStep(idx, "mediaUrl", `Enviando ${file.name}...`); 
                        const uploadedUrl = await uploadFile(file); 
                        console.log('[FLOUP] onChange → URL recebida do uploadFile:', uploadedUrl);
                        if (uploadedUrl) { 
                          console.log('[FLOUP] onChange → Upload concluído com sucesso:', { stepIndex: idx, uploadedUrl });
                          setForm(prevForm => {
                            const steps = [...prevForm.steps];
                            if (!steps[idx]) {
                              console.warn(`[FLOUP] onChange → Step ${idx} não existe, criando novo step`);
                              steps[idx] = { order: idx + 1, message: "", timeUnit: "minutes", timeValue: 0, mediaUrl: "", mediaType: "url" };
                            }
                            steps[idx] = { ...steps[idx], mediaUrl: uploadedUrl, uploadedFile: file };
                            console.log('[FLOUP] onChange → Step atualizado:', steps[idx]);
                            return { ...prevForm, steps };
                          });
                        } else { 
                          console.error('[FLOUP] onChange → Erro no upload do arquivo - uploadedUrl é null');
                          updateStep(idx, "mediaUrl", ""); 
                          alert("Erro no upload do arquivo. Verifique o console para mais detalhes."); 
                        } 
                        if (inputElement) {
                          inputElement.value = '';
                        }
                      } else {
                        console.log('[FLOUP] onChange → Nenhum arquivo selecionado');
                        if (inputElement) {
                          inputElement.value = '';
                        }
                      }
                    }} 
                  />
                  {!step.mediaUrl || step.mediaUrl.includes('Enviando') ? (
                    <>
                      <label htmlFor={`file-upload-${idx}`}>
                        <button 
                          type="button"
                          onClick={() => document.getElementById(`file-upload-${idx}`).click()}
                          style={{ 
                            padding: '6px 12px', 
                            border: '1px solid var(--primaryColor, #065183)', 
                            background: '#fff',
                            color: 'var(--primaryColor, #065183)',
                            borderRadius: 4,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4
                          }}
                        >
                          ☁️ Escolher Arquivo
                        </button>
                      </label>
                      {step.mediaUrl && step.mediaUrl.includes('Enviando') && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <span style={{ fontSize: 16, color: 'var(--primaryColor, #065183)' }}>☁️</span>
                          <span style={{ fontSize: 12, color: '#666' }}>
                            {step.mediaUrl.replace('Enviando ', '')}
                          </span>
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ 
                      flex: 1,
                      padding: '4px 8px',
                      borderRadius: 4,
                      background: '#f5f5f5',
                      border: '1px solid #e0e0e0',
                      minWidth: 0,
                      maxWidth: 400,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4
                    }}>
                      {isImageFile(step.mediaUrl) ? (
                        <img 
                          src={step.mediaUrl} 
                          alt="Preview" 
                          style={{ 
                            width: 24, 
                            height: 24,
                            objectFit: 'cover', 
                            borderRadius: 2,
                            border: '1px solid #e0e0e0',
                            flexShrink: 0
                          }}
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                      ) : isVideoFile(step.mediaUrl) ? (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            const videoUrl = step.mediaUrl;
                            const newWindow = window.open('', '_blank');
                            if (newWindow) {
                              newWindow.document.write(`
                                <html>
                                  <head><title>Player de Vídeo</title></head>
                                  <body style="margin:0;padding:0;background:#000;display:flex;justify-content:center;align-items:center;height:100vh;">
                                    <video controls autoplay style="max-width:100%;max-height:100%;">
                                      <source src="${videoUrl}" type="video/mp4">
                                      Seu navegador não suporta o elemento de vídeo.
                                    </video>
                                  </body>
                                </html>
                              `);
                            }
                          }}
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: 2,
                            border: '1px solid #e0e0e0',
                            overflow: 'hidden',
                            position: 'relative',
                            cursor: 'pointer',
                            flexShrink: 0
                          }}
                        >
                          <video
                            src={step.mediaUrl}
                            preload="metadata"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                          <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            borderRadius: '50%',
                            padding: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            <span style={{ fontSize: 12, color: '#fff' }}>▶</span>
                          </div>
                        </div>
                      ) : (
                        <span style={{ fontSize: 16, color: '#666', flexShrink: 0 }}>📎</span>
                      )}
                      <span style={{ 
                        color: '#333',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        flex: 1,
                        fontSize: 12
                      }}>
                        {step.mediaUrl.split('/').pop() || step.mediaUrl}
                      </span>
                      <button 
                        onClick={async () => {
                          const fileUrlToDelete = step.mediaUrl;
                          console.log('[FLOUP] Removendo mídia do step:', idx, 'URL:', fileUrlToDelete);
                          await deleteFile(fileUrlToDelete);
                          updateStep(idx, "mediaUrl", "");
                          updateStep(idx, "uploadedFile", null);
                        }}
                        title="Remover mídia"
                        style={{ 
                          padding: 4, 
                          border: 'none', 
                          background: 'transparent', 
                          cursor: 'pointer',
                          fontSize: 16,
                          marginLeft: 4
                        }}
                      >
                        🗑️
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button 
              onClick={() => removeStep(idx)} 
              style={{ 
                padding: '8px 16px', 
                border: '1px solid #f44336', 
                background: '#fff',
                color: '#f44336',
                borderRadius: 4,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 4
              }}
            >
              🗑️ Remover Passo
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const renderPreview = () => {
    if (!preview) return null;
    return (
      <div style={{ marginTop: 16, border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
        <div style={{ padding: 16, background: '#fff' }}>
          <h3 style={{ margin: '0 0 12px 0', fontSize: 16, fontWeight: 600 }}>Preview da Mensagem</h3>
          <div style={{ 
            padding: 16, 
            whiteSpace: 'pre-wrap', 
            background: '#f5f5f5', 
            color: '#333', 
            fontFamily: 'monospace', 
            fontSize: 14,
            border: '1px solid #e0e0e0',
            borderRadius: 4
          }}>
            {preview}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
            <span style={{ 
              padding: '4px 8px', 
              borderRadius: 4, 
              background: '#ff9800', 
              color: '#fff',
              fontSize: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 4
            }}>
              📎 Anexo
            </span>
            <span style={{ marginLeft: 8, fontSize: 12, color: '#666' }}>Ícone de anexo aparecerá aqui</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ padding: 24, background: '#f5f7fa', minHeight: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600 }}>📨 Follow UP - Templates de Fluxo</h1>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input 
            type="file" 
            accept=".json" 
            onChange={handleImport}
            style={{ display: 'none' }}
            id="import-floup-file"
          />
          <button 
            onClick={() => document.getElementById('import-floup-file').click()}
            title="Importar Fluxo(s)"
            style={{ 
              padding: '8px 16px',
              background: '#fff', 
              color: 'var(--primaryColor, #065183)', 
              border: '1px solid var(--primaryColor, #065183)', 
              borderRadius: 4, 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontSize: 14,
              fontWeight: 500,
              transition: 'all 0.2s'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'var(--primaryColor, #065183)';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.color = 'var(--primaryColor, #065183)';
            }}
          >
            📥 Importar
          </button>
          <button 
            onClick={handleExportAll}
            title="Exportar Todos os Fluxos"
            disabled={floups.length === 0}
            style={{ 
              padding: '8px 16px',
              background: floups.length === 0 ? '#ccc' : '#fff', 
              color: floups.length === 0 ? '#666' : 'var(--primaryColor, #065183)', 
              border: `1px solid ${floups.length === 0 ? '#ccc' : 'var(--primaryColor, #065183)'}`, 
              borderRadius: 4, 
              cursor: floups.length === 0 ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontSize: 14,
              fontWeight: 500,
              transition: 'all 0.2s',
              opacity: floups.length === 0 ? 0.6 : 1
            }}
            onMouseEnter={e => {
              if (floups.length > 0) {
                e.currentTarget.style.background = 'var(--primaryColor, #065183)';
                e.currentTarget.style.color = '#fff';
              }
            }}
            onMouseLeave={e => {
              if (floups.length > 0) {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = 'var(--primaryColor, #065183)';
              }
            }}
          >
            📤 Exportar Todos
          </button>
          <button 
            onClick={() => { resetForm(); setOpen(true); }}
            title="Novo Template"
            style={{ 
              width: 40,
              height: 40,
              background: 'var(--primaryColor, #065183)', 
              color: '#fff', 
              border: 'none', 
              borderRadius: 4, 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20,
              fontWeight: 500,
              transition: 'all 0.2s'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.opacity = '0.8';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.opacity = '1';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            +
          </button>
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e0e0e0' }}>
        {floups.map((f, index) => (
          <div key={f.id}>
            <div style={{ 
              padding: 16, 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'flex-start'
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>{f.name}</div>
                <div style={{ fontSize: 14, color: '#666', marginBottom: 8 }}>{f.description}</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <span style={{ 
                    padding: '4px 8px', 
                    borderRadius: 4, 
                    border: '1px solid var(--primaryColor, #065183)',
                    color: 'var(--primaryColor, #065183)',
                    fontSize: 12
                  }}>
                    {f.templateType || "personalizado"}
                  </span>
                  <span style={{ 
                    padding: '4px 8px', 
                    borderRadius: 4, 
                    border: '1px solid #e0e0e0',
                    color: '#666',
                    fontSize: 12
                  }}>
                    {(f.steps || []).length} passos
                  </span>
                  <span style={{ 
                    padding: '4px 8px', 
                    borderRadius: 4, 
                    background: f.isActive ? '#4caf50' : '#e0e0e0',
                    color: '#fff',
                    fontSize: 12
                  }}>
                    {f.isActive ? "Ativo" : "Inativo"}
                  </span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  onClick={() => { 
                    const stepsToLoad = f.steps || [];
                    console.log('[FLOUP] Carregando Floup para edição:', {
                      id: f.id,
                      name: f.name,
                      stepsCount: stepsToLoad.length,
                      stepsWithMedia: stepsToLoad.filter(s => s.mediaUrl).map(s => ({ order: s.order, mediaUrl: s.mediaUrl }))
                    });
                    setForm({ 
                      id: f.id, 
                      name: f.name, 
                      description: f.description, 
                      templateType: f.templateType || "personalizado", 
                      condition: f.condition || "queue",
                      conditionValue: f.conditionValue || "",
                      steps: stepsToLoad, 
                      stopConditions: f.stopConditions || [], 
                      pauseConditions: f.pauseConditions || [] 
                    }); 
                    setOpen(true); 
                  }}
                  title="Editar"
                  style={{ 
                    padding: 8, 
                    border: 'none', 
                    background: 'transparent', 
                    cursor: 'pointer',
                    fontSize: 18
                  }}
                >
                  ✏️
                </button>
                <button
                  onClick={() => handleDuplicate(f.id)}
                  title="Duplicar"
                  style={{ 
                    padding: 8, 
                    border: 'none', 
                    background: 'transparent', 
                    cursor: 'pointer',
                    fontSize: 18
                  }}
                >
                  📋
                </button>
                <button
                  onClick={() => handleExport(f.id)}
                  title="Exportar este fluxo"
                  style={{ 
                    padding: 8, 
                    border: 'none', 
                    background: 'transparent', 
                    cursor: 'pointer',
                    fontSize: 18
                  }}
                >
                  📤
                </button>
                <button
                  onClick={() => handleDelete(f.id)}
                  title="Deletar"
                  style={{ 
                    padding: 8, 
                    border: 'none', 
                    background: 'transparent', 
                    cursor: 'pointer',
                    fontSize: 18
                  }}
                >
                  🗑️
                </button>
              </div>
            </div>
            {index < floups.length - 1 && <div style={{ borderBottom: '1px solid #e0e0e0' }} />}
          </div>
        ))}
      </div>

      {/* Modal de Edição/Criação */}
      {open && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'rgba(0,0,0,0.5)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          zIndex: 1000,
          padding: 20
        }}>
          <div style={{ 
            background: '#fff', 
            borderRadius: 8, 
            maxWidth: 1000, 
            width: '100%', 
            maxHeight: '90vh', 
            display: 'flex', 
            flexDirection: 'column'
          }}>
            <div style={{ 
              padding: '16px 24px', 
              borderBottom: '1px solid #e0e0e0',
              display: 'flex',
              alignItems: 'center',
              gap: 12
            }}>
              <span style={{ fontSize: 24 }}>⏰</span>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>
                {form.id ? "Editar Template" : "Novo Template"}
              </h2>
            </div>
            
            <div style={{ padding: 24, overflowY: 'auto', flex: 1 }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Informações Básicas</h3>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Nome do Template</label>
                  <input 
                    type="text"
                    value={form.name} 
                    onChange={e => setForm({ ...form, name: e.target.value })} 
                    style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Tipo do Template</label>
                  <select 
                    value={form.templateType} 
                    onChange={e => { 
                      const config = getTemplateTypeConfig(e.target.value); 
                      setForm({ ...form, templateType: e.target.value, steps: config.defaultSteps }); 
                    }}
                    style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
                  >
                    <option value="cliente">Cliente</option>
                    <option value="lead">Lead</option>
                    <option value="personalizado">Personalizado</option>
                  </select>
                </div>
              </div>
              
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Descrição</label>
                <textarea 
                  value={form.description} 
                  onChange={e => setForm({ ...form, description: e.target.value })} 
                  rows={2}
                  style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4, fontFamily: 'inherit' }}
                />
              </div>
              
              <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: 16, marginTop: 16, marginBottom: 16 }}>
                <h4 style={{ margin: '0 0 8px 0', fontSize: 14, fontWeight: 600 }}>Condição para Acionamento</h4>
                <p style={{ margin: '0 0 16px 0', fontSize: 14, color: '#666' }}>
                  Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.
                </p>
              </div>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Condição</label>
                  <select 
                    value={form.condition || "queue"} 
                    onChange={e => setForm({ ...form, condition: e.target.value, conditionValue: "" })} 
                    style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
                  >
                    <option value="queue">Fila do sistema</option>
                    <option value="tag">Tag do sistema</option>
                    <option value="firstClientInteraction">Primeira interação do cliente</option>
                    <option value="firstAttendantInteraction">Primeira interação do atendente</option>
                  </select>
                </div>
                <div>
                  {form.condition === "queue" && (
                    <>
                      <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>&nbsp;</label>
                      <select 
                        value={form.conditionValue || ""} 
                        onChange={e => setForm({ ...form, conditionValue: e.target.value })} 
                        style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
                      >
                        <option value="">Selecionar fila</option>
                        {queues.map(q => (<option key={q.id} value={q.name}>{q.name}</option>))}
                      </select>
                    </>
                  )}
                  {form.condition === "tag" && (
                    <>
                      <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>&nbsp;</label>
                      <select 
                        value={form.conditionValue || ""} 
                        onChange={e => setForm({ ...form, conditionValue: e.target.value })} 
                        style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
                      >
                        <option value="">Selecionar tag</option>
                        {tags.map(t => (<option key={t.id} value={t.name}>{t.name}</option>))}
                      </select>
                    </>
                  )}
                  {(form.condition === "firstClientInteraction" || form.condition === "firstAttendantInteraction") && (
                    <>
                      <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Descrição da condição</label>
                      <input 
                        type="text"
                        value={form.conditionValue || ""} 
                        onChange={e => setForm({ ...form, conditionValue: e.target.value })} 
                        placeholder="Ex: Cliente enviou primeira mensagem"
                        style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4 }}
                      />
                    </>
                  )}
                </div>
              </div>
              
              <div style={{ 
                padding: 16, 
                background: '#e3f2fd', 
                border: '1px solid #2196f3',
                borderRadius: 4,
                marginBottom: 16
              }}>
                <div style={{ fontSize: 14, color: '#1976d2' }}>
                  <strong>{getTemplateTypeConfig(form.templateType).title}</strong><br/>
                  {getTemplateTypeConfig(form.templateType).description}
                </div>
              </div>
              
              <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: 16, marginTop: 16, marginBottom: 16 }}>
                <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Controles de Parada do Fluxo</h3>
                <div style={{ 
                  padding: 16, 
                  background: '#fff3e0', 
                  border: '1px solid #ff9800',
                  borderRadius: 4
                }}>
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                      <input 
                        type="checkbox"
                        checked={form.stopConditions?.some(c => c.type === 'anyMessage') || false} 
                        onChange={e => {
                          const stopConditions = form.stopConditions || [];
                          if (e.target.checked) {
                            if (!stopConditions.some(c => c.type === 'anyMessage')) {
                              setForm({ ...form, stopConditions: [...stopConditions, { type: 'anyMessage', enabled: true }] });
                            }
                          } else {
                            setForm({ ...form, stopConditions: stopConditions.filter(c => c.type !== 'anyMessage') });
                          }
                        }} 
                        style={{ width: 18, height: 18 }}
                      />
                      <span style={{ fontSize: 14 }}>1. Caso o Contato responder qualquer mensagem</span>
                    </label>
                  </div>
                  
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                      <input 
                        type="checkbox"
                        checked={form.stopConditions?.some(c => c.type === 'keyword') || false} 
                        onChange={e => {
                          const stopConditions = form.stopConditions || [];
                          if (e.target.checked) {
                            if (!stopConditions.some(c => c.type === 'keyword')) {
                              setForm({ ...form, stopConditions: [...stopConditions, { type: 'keyword', enabled: true, keyword: '' }] });
                            }
                          } else {
                            setForm({ ...form, stopConditions: stopConditions.filter(c => c.type !== 'keyword') });
                          }
                        }} 
                        style={{ width: 18, height: 18 }}
                      />
                      <span style={{ fontSize: 14 }}>2. Caso o Contato responder uma Palavra chave</span>
                    </label>
                    {form.stopConditions?.some(c => c.type === 'keyword') && (
                      <input 
                        type="text"
                        value={form.stopConditions.find(c => c.type === 'keyword')?.keyword || ''} 
                        onChange={e => {
                          const stopConditions = form.stopConditions || [];
                          const keywordCondition = stopConditions.find(c => c.type === 'keyword');
                          if (keywordCondition) {
                            keywordCondition.keyword = e.target.value;
                            setForm({ ...form, stopConditions: [...stopConditions.filter(c => c.type !== 'keyword'), keywordCondition] });
                          }
                        }} 
                        placeholder="Ex: PARAR, CANCELAR, SAIR" 
                        style={{ width: '100%', padding: 8, border: '1px solid #e0e0e0', borderRadius: 4, marginTop: 8, marginLeft: 26 }}
                      />
                    )}
                  </div>
                  
                  <div>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                      <input 
                        type="checkbox"
                        checked={form.stopConditions?.some(c => c.type === 'ticketClosed') || false} 
                        onChange={e => {
                          const stopConditions = form.stopConditions || [];
                          if (e.target.checked) {
                            if (!stopConditions.some(c => c.type === 'ticketClosed')) {
                              setForm({ ...form, stopConditions: [...stopConditions, { type: 'ticketClosed', enabled: true }] });
                            }
                          } else {
                            setForm({ ...form, stopConditions: stopConditions.filter(c => c.type !== 'ticketClosed') });
                          }
                        }} 
                        style={{ width: 18, height: 18 }}
                      />
                      <span style={{ fontSize: 14 }}>3. Caso o Ticket for Fechado</span>
                    </label>
                  </div>
                </div>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, marginBottom: 16 }}>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>Passos do Fluxo</h3>
                <button 
                  onClick={addStep} 
                  style={{ 
                    padding: '8px 16px', 
                    border: '1px solid var(--primaryColor, #065183)', 
                    background: '#fff',
                    color: 'var(--primaryColor, #065183)',
                    borderRadius: 4,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4
                  }}
                >
                  ➕ Adicionar Passo
                </button>
              </div>
              
              {form.steps.map((step, idx) => renderStepForm(step, idx))}
              {renderPreview()}
            </div>
            
            <div style={{ 
              padding: '16px 24px', 
              borderTop: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 12
            }}>
              <button 
                onClick={() => setOpen(false)} 
                style={{ 
                  padding: '10px 20px', 
                  border: '1px solid #e0e0e0', 
                  background: '#fff', 
                  borderRadius: 4, 
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8
                }}
              >
                ❌ Cancelar
              </button>
              <button 
                onClick={handleSave} 
                disabled={!form.name || form.steps.length === 0}
                style={{ 
                  padding: '10px 20px', 
                  background: (!form.name || form.steps.length === 0) ? '#ccc' : 'var(--primaryColor, #065183)', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: 4, 
                  cursor: (!form.name || form.steps.length === 0) ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  opacity: (!form.name || form.steps.length === 0) ? 0.6 : 1
                }}
              >
                💾 Salvar Template
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Exclusão */}
      {deleteConfirmOpen && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'rgba(0,0,0,0.5)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{ 
            background: '#fff', 
            borderRadius: 8, 
            maxWidth: 500, 
            width: '100%', 
            margin: 20
          }}>
            <div style={{ 
              padding: '16px 24px', 
              borderBottom: '1px solid #e0e0e0'
            }}>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>Confirmar Exclusão</h2>
            </div>
            
            <div style={{ padding: 24 }}>
              <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6 }}>
                Tem certeza que deseja deletar o Follow UP <strong>"{floupToDelete?.name}"</strong>?
                <br />
                <br />
                Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.
              </p>
            </div>
            
            <div style={{ 
              padding: '16px 24px', 
              borderTop: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 12
            }}>
              <button 
                onClick={() => { setDeleteConfirmOpen(false); setFloupToDelete(null); }} 
                style={{ 
                  padding: '10px 20px', 
                  border: '1px solid #e0e0e0', 
                  background: '#fff', 
                  borderRadius: 4, 
                  cursor: 'pointer'
                }}
              >
                Cancelar
              </button>
              <button 
                onClick={confirmDelete} 
                style={{ 
                  padding: '10px 20px', 
                  background: '#f44336', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: 4, 
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8
                }}
              >
                🗑️ Deletar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloupPage;
